import { render, staticRenderFns } from "./RightChart3.vue?vue&type=template&id=387adec4&scoped=true&"
import script from "./RightChart3.vue?vue&type=script&lang=js&"
export * from "./RightChart3.vue?vue&type=script&lang=js&"
import style0 from "./RightChart3.vue?vue&type=style&index=0&id=387adec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387adec4",
  null
  
)

export default component.exports